import angular from 'angular';
import { CriteriaVisibilityController } from './criteria-visibility.controller';
import { criterionSelector } from './criterion-selector.directive';
import { DateRangePickerDialogService } from './date-range-picker-dialog.service';
import { MetricController } from './metric.controller.js';
import { MetricsService } from './metrics.service.js';
import { MetricsHelperFactory } from './metricsHelper.service.js';
import { monthRangeSelector } from './month-range-selector.directive';
import { SelectorsService } from './selectors-classes/selectors.service';

angular
  .module('metrics', ['chart.js'])
  .controller('MetricController', MetricController)
  .controller('CriteriaVisibilityController', CriteriaVisibilityController)
  .directive('criterionSelector', criterionSelector)
  .directive('monthRangeSelector', monthRangeSelector)
  .factory('MetricsHelperFactory', MetricsHelperFactory)
  .factory('MetricsFactory', MetricsService.MetricsFactory)
  .factory('DateRangePickerDialogFactory', DateRangePickerDialogService.DateRangePickerDialogFactory)
  .factory('SelectorsFactory', SelectorsService.SelectorsFactory);
